module.exports = __webpack_public_path__ + "img/excavator-orange.9574d63f.svg";